var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcArrowUp16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.769 10.76a.77.77 0 0 1-1.117 0L8 6.975 4.348 10.76a.77.77 0 0 1-1.117 0 .84.84 0 0 1 0-1.157l4.21-4.363a.77.77 0 0 1 1.117 0l4.21 4.363a.84.84 0 0 1 0 1.157",
  clipRule: "evenodd"
})));
export default SvgIcArrowUp16;